import React, { Fragment } from "react";
import { makeStyles } from "@mui/styles";
import { Chip, Avatar } from "@mui/material";
import { TC, TP, TR } from "~constants/tipoPoliza";
import { emphasize } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  avatar: {
    color: "white",
    height: "100%",
    backgroundColor: theme.colours.violeta,
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
    width: "100%",
  },
  chipFocused: {
    backgroundColor: emphasize(
      // MUI v5 renombró `palette.type` a `palette.mode`, así que esto es
      // `undefined` y la rama siempre cae en grey[700]. Se conserva tal cual; ver SEG-1521.
      (theme.palette as any).type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
}));

interface ChipCoberturaProps {
  label?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onDelete?: React.EventHandler<any>;
  tipoCobertura?: string | null;
  clickable?: boolean;
}

const ChipCobertura: React.FC<ChipCoberturaProps> = ({
  label,
  onClick,
  onDelete,
  tipoCobertura,
  clickable,
}) => {
  const classes = useStyles();

  return (
    <Chip
      clickable={clickable}
      tabIndex={-1}
      label={label}
      className={classes.chip}
      onDelete={onDelete}
      onClick={onClick}
      avatar={
        tipoCobertura === TP ? (
          <Avatar className={classes.avatar}>&#9733;</Avatar>
        ) : (
          <Fragment />
        )
      }
      color={
        tipoCobertura === TR
          ? "primary"
          : tipoCobertura === TC || tipoCobertura === TP
            ? "secondary"
            : "default"
      }
    />
  );
};

export default ChipCobertura;
